import { HttpClient } from "@angular/common/http";
import { environment } from "src/environments/environment";
import NgxTranslateHttpPropertiesLoader
  from "../ngx-translate-http-properties-loader/ngx-translate-http-properties-loader";

export function HttpLoaderFactory(http: HttpClient): NgxTranslateHttpPropertiesLoader {
    return new NgxTranslateHttpPropertiesLoader(http, environment.translationAddressPrefix, environment.translationAddressSuffix);
}

